import BinOption from "../../selectOptions/BinOption";
import FlashPCBSelect from "../../common/FlashPCBSelect";
import React from "react";
import useGetAllInventoryBins from "../../../utils/hooks/inventory/allInventoryBins";
import { InventoryBin } from "../parts/Bins/inventoryBinTypes";

export default function SelectBin({
  onSelectBin,
}: {
  onSelectBin: (newValue: InventoryBin | null) => void;
}) {
  const { inventoryBinsResponse } = useGetAllInventoryBins();

  return (
    <FlashPCBSelect
      label={"Choose existing bin / tote"}
      options={inventoryBinsResponse?.bins}
      filterOption={(option, inputValue: string) => {
        return (
          option.data.bin_name
            .trim()
            .toLowerCase()
            .includes(inputValue.trim().toLowerCase()) ||
          option.data.flashpcb_bin_barcode
            .trim()
            .toLowerCase()
            .includes(inputValue.trim().toLowerCase())
        );
      }}
      isLoading={inventoryBinsResponse === null}
      onChange={onSelectBin}
      isClearable
      formatOptionLabel={(data, formatOptionLabelMeta) => {
        const selectValue = formatOptionLabelMeta.selectValue[0];
        return (
          <BinOption
            bin={data}
            selected={
              selectValue !== undefined &&
              selectValue.flashpcb_bin_barcode == data.flashpcb_bin_barcode
            }
          />
        );
      }}
    />
  );
}
